
export default {
  name: 'ScreenSplitProp',
  props: {
    checked: {
      type: Boolean,
      required: true,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    textContent: {
      type: String,
      required: true
    },
    tipsContent: {
      type: String,
      required: true
    }
  },
  computed: {
    checkedValue: {
      get: function get() {
        // 当 checked 为 false 的时候，显示勾选，反之亦然
        return !this.checked;
      },
      set: function set(val) {
        this.$emit('change', !val);
      }
    }
  }
};